<template>
    <AisPagination @page-change="pageChanged">
        <template
            v-slot="{
                currentRefinement,
                pages,
                refine,
                createURL
            }"
        >
            <div v-show="pages.length > 1">
                <a
                    :href="createURL(currentRefinement - 1)"
                    class="dn-button dn-button--clean ais-pagination__prev"
                    :disabled="currentRefinement === 0"
                    :aria-label="$t('previous')"
                    @click.prevent="refine(currentRefinement - 1)"
                >
                    <sf-icon
                        icon="chevron-left"
                        class="dn-icon--inline"
                    />
                    <span class="hidden">Previous</span>
                </a>
                <a
                    v-for="page in pages"
                    :key="page"
                    :href="createURL(page)"
                    :data-active="page === currentRefinement "
                    class="dn-button dn-button--clean ais-pagination__button"
                    :class="(getStatus(page, pages, currentRefinement) === 'gap') ? 'ais-pagination__gap' : ''"
                    :aria-label="`${$t('page')} ${page + 1}`"
                    @click.prevent="refine(page)"
                >
                    <span v-if="getStatus(page, pages, currentRefinement) === 'gap'">
                        &hellip;
                    </span>
                    <span v-else>
                        {{ page + 1 }}
                    </span>
                </a>
                <a
                    :href="createURL(currentRefinement + 1)"
                    class="dn-button dn-button--clean ais-pagination__next"
                    :disabled="currentRefinement === pages.length - 1"
                    :aria-label="$t('next')"
                    @click.prevent="refine(currentRefinement + 1)"
                >
                    <sf-icon
                        icon="chevron-right"
                        class="dn-icon--inline"
                    />
                    <span class="hidden">Next</span>
                </a>
            </div>
        </template>
    </AisPagination>
</template>

<script>
import { AisPagination } from 'vue-instantsearch/vue3/es/index.js';

import SfIcon from '~/patterns/atoms/icon/icon.vue';

export default {
    components: {
        AisPagination,
        SfIcon
    },
    props: {
        state: {
            type: Object,
            default: null
        }
    },
    methods: {
        getStatus(page, pages, currentRefinement) {
            const totalPages = pages.length - 1;

            if (
                // Check if active page
                page === currentRefinement
            ) {
                return 'active';
            } else if (
                // Check if first or last page
                page === 0 ||
                page === totalPages
            ) {
                return '';
            } else if (
                // If first page pad an extra following page
                currentRefinement === 0 &&
                page === (currentRefinement + 2)
            ) {
                return '';
            } else if (
                // If last page pad an extra leading page
                currentRefinement === totalPages &&
                page === (currentRefinement - 2)
            ) {
                return '';
            } else if (
                // Pad surrounding pages
                page === (currentRefinement + 1) ||
                page === (currentRefinement - 1)
            ) {
                return '';
            } else {
                return 'gap';
            }
        },

        pageChanged() {
            window.scrollTo(0, 0);
        }
    }
};
</script>

<style lang="less" src="./pagination.less"></style>

<i18n lang="json">
    {
        "nl": {
            "page": "pagina",
            "next": "volgende pagina",
            "previous": "vorige pagina"
        },
        "en": {
            "page": "page",
            "next": "next page",
            "previous": "previous page"
        }
    }
</i18n>
